/**
 * general
 *
 * Handle generic functions used by the application
 */
import React, { useEffect, useState } from 'react';

/* eslint prefer-template: 0 */
/* eslint no-undef: 0 */

/**
 * Register event listener.
 *
 * NOTE: window.attachEvent is used for IE < 9. So if using "this" within
 * the event, it will reference the window object and not the function.
 *
 * @param element
 * @param event
 * @param func
 * @param options
 */
export const registerListener = (element, event, func, options) => {
  element.addEventListener ? element.addEventListener(event, func, options) : element.attachEvent('on' + event, func);
};

/**
 * Remove event listener.
 *
 * @param element
 * @param event
 * @param func
 * @param options
 */
export const removeListener = (element, event, func, options) => {
  element.removeEventListener ? element.removeEventListener(event, func, options) : element.detachEvent('on' + event, func);
};

/**
 * Used in conjunction with useWindowDimensions to return width/height object
 */
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

/**
 * Function to set and return the windows width/height.
 * To Use:
 *    const { height, width } = useWindowDimensions();
 *
 * @returns {{width: number, height: number}}
 */
export const useWindowDimensions = () => {
  if (typeof window === 'undefined') return {};

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    registerListener(window, 'resize', handleResize);
    return () => removeListener(window, 'resize', handleResize);
  }, []);

  return windowDimensions;
};

/**
 * LOAD EXTERNAL JS FILES
 *
 * @param url
 * @param onload
 */
export const addScript = (url, onload) => {
  const script = document.createElement('script');
  script.src = url;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);

  if (onload) {
    script.onload = onload;
  }
};

/**
 * Async function to remove a script node
 *
 * @param tagName
 * @param src
 * @returns {Promise<void>}
 */
export const removeNode = (tagName, src) => {
  [...document.getElementsByTagName(tagName)].filter(tag => {
    if (tag.getAttribute('src') === src) {
      tag.remove();
      // console.log('Tag: ', tag); /* eslint-disable-line no-console */
    }
  });
};

/**
 * Finds the closest parent node with a specific classNameToFind
 *
 * @param el
 * @param classNameToFind
 * @returns {*}
 */

// export const getClosestElem = (el, classNameToFind) => {
//   let tempEl = el;
//
//   console.log(typeof document);
//   if (typeof document !== 'undefined') {
//     for (; tempEl && tempEl !== document; tempEl = tempEl.parentNode) {
//       if (tempEl.classList.contains(classNameToFind)) {
//         return tempEl;
//       }
//     }
//   }
//
//   return null;
// };
